import React, { useEffect, useState } from 'react';
import { useDebounce } from 'react-use';
import { Drawer, Layout, Menu, Typography } from 'antd';
import styled from 'styled-components';

// Redux
import { useAppDispatch, useAppSelector } from '../../../hooks/App/useRedux';
import { openSidebar, updateWindowWidth } from '../../../store/AppSettings/AppSettings.redux';

// Components
import { CustomScrollbars } from '../../UI/Core/CustomScrollbars';
import { Translated } from '../../UI/Core/Translated';

// Constants
import { findOpenKey } from '../../../constants/Utils/UIFunctions';
import { useMenuItems } from '../../../data/Menu/MenuItems';

// Subcomponents
const { Sider } = Layout;
const { Title } = Typography;

// Styled Title
const StyledTitle = styled(Title)`
  padding: 20px 20px 0px 20px;
`;

// Component
export const MobileMenu = () => {
  // Redux
  const dispatch = useAppDispatch();
  const { sidebarOpen, width } = useAppSelector(({ appSettings }) => appSettings);

  // Debounced* | Updates app width and closes the drawer accordingly
  const [currentWidth, setCurrentWidth] = useState(width);
  useDebounce(() => dispatch(updateWindowWidth(currentWidth)), 200, [currentWidth]);
  useEffect(() => window.addEventListener('resize', () => setCurrentWidth(window.innerWidth)), [dispatch]);

  // UI Handlers
  const onToggleCollapsedNav = () => {
    dispatch(openSidebar(!sidebarOpen));
  };

  // Keys for Menu
  const pathname = useAppSelector(({ appSettings }) => appSettings?.pathname ?? '/');
  const selectedKey = pathname === '/' ? 'Dashboard' : pathname.substring(1).split('/')[0];
  const menuItems = useMenuItems();
  const defaultOpenKey = findOpenKey(selectedKey, menuItems ?? []);

  return (
    <Sider className="gx-app-sidebar gx-collapsed-sidebar">
      <Drawer
        className="gx-drawer-sidebar"
        placement="left"
        closable={false}
        onClose={onToggleCollapsedNav}
        open={sidebarOpen}
      >
        <div className="gx-sidebar-content">
          <CustomScrollbars className="gx-layout-sider-scrollbar">
            <StyledTitle level={5}>
              <Translated id="app.name" />
            </StyledTitle>
            <Menu defaultOpenKeys={[defaultOpenKey]} selectedKeys={[selectedKey]} items={menuItems} mode="inline" />
          </CustomScrollbars>
        </div>
      </Drawer>
    </Sider>
  );
};
